import * as React from "react";
import { observer } from "mobx-react-lite";
import systemStore from "../../storage/SystemStore";
import { ProgressSpinner } from "primereact/progressspinner";
import "./Loading.css";

const MIN_SHOW_MS = 250;

const Loading = observer(() => {
  const [visible, setVisible] = React.useState(false);
  const shownAtRef = React.useRef(0);
  const tRef = React.useRef(null);

  React.useEffect(() => {
    if (tRef.current) clearTimeout(tRef.current);

    if (systemStore.loading) {
      shownAtRef.current = Date.now();
      setVisible(true);
      return;
    }

    // hide with minimum display time
    const elapsed = Date.now() - shownAtRef.current;
    const delay = Math.max(0, MIN_SHOW_MS - elapsed);

    tRef.current = setTimeout(() => setVisible(false), delay);

    return () => tRef.current && clearTimeout(tRef.current);
  }, [systemStore.loading]);

  return (
    <div className={`loading ${visible ? "is-visible" : ""}`}>
      <div className="loading_content">
        <ProgressSpinner />
      </div>
    </div>
  );
});

export default Loading;
